export const initAdaptiveSticky = (className = 'catalog__controls--fixed') => {
    const parentElement = document.querySelector('[data-adaptive-sticky]');
    if (!parentElement) return;

    const stickyElement = parentElement.children[0];
    if (!stickyElement) return;

    const STICKY_CLASSNAME = className;
    const TOP_OFFSET = +parentElement.dataset.adaptiveSticky || 0;

    const setOffsetHeight = () => {
        const { height } = parentElement.getBoundingClientRect();
        parentElement.style.height = `${height}px`;
    };

    const scrollDocumentHandler = () => {
        if (window.outerWidth < 576) {
            const { top } = parentElement.getBoundingClientRect();

            if (top < TOP_OFFSET) {
                stickyElement.classList.add(STICKY_CLASSNAME);
            } else {
                stickyElement.classList.remove(STICKY_CLASSNAME);
            }
        }
    };

    setOffsetHeight();

    document.addEventListener('scroll', scrollDocumentHandler);
    document.addEventListener('resize', () => setOffsetHeight());
};
